export const buildUsers = (users, profiles) => users.map(user => buildUser(user, profiles));

export const buildUser = (user, profiles) => {
    if (!user) return null;
  
    return {
      ...user,
      company: Array.isArray(user.company) ? user.company[0] : user.company,
      profile: profiles
        ? buildUserProfile(user.profile, profiles)
        : Array.isArray(user.profile)
          ? user.profile[0]
          : user.profile,
      displayName: `${user.name} ${user.last_name}`,
      displayNameWithUsername: `${user.name} ${user.last_name} (${user.username})`
    };
  };
  
const buildUserProfile = (user_profile, profiles) => profiles.find(profile => profile._id === user_profile[0]);
